export default __webpack_public_path__ + "static/media/Web 1349 – Analyse des marchés.246ccb63.svg";